module.exports = __webpack_public_path__ + "static/media/yin-yang.e52a5d1e.svg";